module.exports = __webpack_public_path__ + "static/media/6-item-a.1459ebf4.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/women/6-item-a.jpg
// module id = 1201
// module chunks = 33